import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  rangeDatePicker: {
    display: 'inline-block',
    verticalAlign: 'top',
    '& .react-datepicker-popper': {
      zIndex: '100'
    },
    '& .MuiFormControl-root': {
      minWidth: '242px'
    },
    '& .MuiInputBase-adornedEnd .MuiSvgIcon-root path': {
      fill: palette.shades[500]
    },
    '& .react-datepicker': {
      fontFamily: palette.fontFamilies.poppins,
      border: 'none',
      boxShadow: palette.shadows.hard,
      borderRadius: '2px',
      padding: '20px'
    },
    '& .react-datepicker__current-month': {
      fontSize: '15px',
      marginBottom: '15px'
    },
    '& .react-datepicker__month': {
      margin: '0 5px',
      textAlign: 'left'
    },
    '& .react-datepicker__header': {
      backgroundColor: 'transparent',
      borderBottom: 'none',
      paddingTop: '0px',
      paddingBottom: '15px'
    },
    '& .react-datepicker__triangle': {
      display: 'none'
    },
    '& .react-datepicker__navigation--previous': {
      left: '16px',
      top: '15px'
    },
    '& .react-datepicker__navigation--next': {
      right: '16px',
      top: '15px'
    },
    '& .react-datepicker__navigation-icon::before': {
      height: '12px',
      width: '12px',
      borderColor: palette.primary.main
    },
    '& .react-datepicker__month-text': {
      width: '60px',
      borderRadius: '2px',
      margin: '2px',
      padding: '7px 0',
      textAlign: 'center',
      backgroundColor: palette.shades[200],
      color: palette.shades[700],
      '&:hover': {
        backgroundColor: palette.primary.light,
        color: palette.shades[100]
      }
    },
    '& .react-datepicker__month-text--keyboard-selected': {
      backgroundColor: palette.shades[200],
      color: palette.shades[700]
    },
    '& .react-datepicker__month-text--in-selecting-range': {
      backgroundColor: palette.primary.light,
      color: palette.shades[100],
      '&:hover': {
        backgroundColor: palette.primary.light,
        color: palette.shades[100]
      }
    },
    '& .react-datepicker__month-text--in-range': {
      backgroundColor: palette.primary.light,
      color: palette.shades[100],
      '&:hover': {
        backgroundColor: palette.primary.light,
        color: palette.shades[100]
      }
    },
    '& .react-datepicker__month-text--selected': {
      backgroundColor: palette.primary.light,
      color: palette.shades[100],
      '&:hover': {
        backgroundColor: palette.primary.light,
        color: palette.shades[100]
      }
    },
    '& .react-datepicker__month-text--range-start, .react-datepicker__month-text--range-end': {
      backgroundColor: palette.primary.main,
      color: palette.shades[100],
      '&.react-datepicker__month-text--in-range': {
        '&:hover': {
          backgroundColor: palette.primary.main,
          color: palette.shades[100]
        }
      }
    },
    '& .react-datepicker__month--selected': {
      backgroundColor: palette.primary.main,
      color: palette.shades[100],
      '&:hover': {
        backgroundColor: palette.primary.main,
        color: palette.shades[100]
      }
    }
  }
});
export default useStyles;